import { ReactNode, useState, useCallback } from 'react';

import Device from '~interfaces/device';

import SelectedDevicesContext from './selectedDevicesContext';

interface DeviceProviderProps {
	children: ReactNode;
}

export const SelectedDevicesProvider = ({ children }: DeviceProviderProps) => {
	const [selectedDevices, setSelectedDevices] = useState<Device[]>([]);
	const [singleDevice, setSingleDevice] = useState<Device | undefined>(undefined);

	const addDevice = useCallback((device: Device) => {
		setSelectedDevices((prev) =>
			prev.find((selectedDevice) => selectedDevice.id == device.id) ? prev : [...prev, device]
		);
	}, []);

	const removeDevice = useCallback((device: Device) => {
		setSelectedDevices((prev) => prev.filter((selectedDevice) => selectedDevice.id !== device.id));
	}, []);

	const replaceSelectedDevices = useCallback((devices: Device[]) => {
		setSelectedDevices(devices);
	}, []);

	const updateSingleDevice = useCallback((device: Device | undefined) => {
		setSingleDevice(device);
	}, []);

	return (
		<SelectedDevicesContext
			value={{
				selectedDevices,
				singleDevice,
				addDevice,
				removeDevice,
				replaceSelectedDevices,
				updateSingleDevice,
			}}
		>
			{children}
		</SelectedDevicesContext>
	);
};

export default SelectedDevicesProvider;
